export default (options, { searchBy, searchByProp, returnProp }) => {
  if(!searchBy)
    return null;

  const actionResult = options.find(a => a[searchByProp].toString() === searchBy.toString());
  return actionResult[returnProp] || null;
}
